import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ConnectivityRegistryForm from './ConnectivityRegistryForm';
const ConnectivityCheckoutStepPersonalData = (props) => {
    const { t } = useTranslation();
    const { product } = useSelector((state) => state.connectivity);
    if (!product) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "checkout-connectivity--personaldata" },
        React.createElement(ConnectivityRegistryForm, Object.assign({}, props, { setErrors: props.setErrors }))));
};
export default ConnectivityCheckoutStepPersonalData;
